import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styles from '../../../components/common/Button/Button.module.scss';

export default function BulkInventoryEditActionButton({
  isEditEnabled,
  onClick,
  buttonText,
  tooltipText,
  tooltipPlacement = 'bottom',
  tooltipId = 'edit-tooltip',
}) {
  const buttonClasses = [styles.container, styles['color-white']];

  if (!isEditEnabled) {
    buttonClasses.push(styles.disabled);
  }

  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={
        <Tooltip hidden={!tooltipText || !isEditEnabled} id={tooltipId}>
          <h5>{tooltipText}</h5>
        </Tooltip>
      }
    >
      <button
        className={classNames(buttonClasses)}
        type="button"
        onClick={onClick}
        disabled={!isEditEnabled}
        data-testid={'bulk-edit-button'}
        color="white"
      >
        <span>{buttonText}</span>
      </button>
    </OverlayTrigger>
  );
}
